define((require) => {
    "use strict";

    var _                    = require("underscore"),
        Action               = require("editor/util/Action"),
        CompositeWidgetModel = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel"),
        LayerEnum            = require("ui/editor/LayerEnum"),
        $                    = require("jquery"),
        WidgetTypes          = require("shared/ui/experience/widgets/WidgetTypes");

    /**
     * An action for adding widgets to a scene
     *
     * @class AddWidgetsAction
     */
    return Action.extend({

        _sceneModel: null,

        _widgetModels: [],

        _doNotSelect: false,

        _options: null,

        /**
         * Constructor
         * @param {Scene} sceneModel    A scene model.
         * @param {AbstractWidgetModel[]} widgetModels  Array of things extending <tt>AbstractWidgetModel</tt>'s.
         * @param {EditorViewModel} viewModel
         * @param {doNotSelect} a boolean used to toggle whether to select the widgets (used in the DynamicProductWidget), default is false
         */
        constructor: function(sceneModel, widgetModels, editorViewModel, select, options) {
            this.__super();

            this._widgetModels = widgetModels;

            this._sceneModel = sceneModel;
            this._editorViewModel = editorViewModel;

            if (select) {
                this._doNotSelect = select;
            }

            this._options = options;
        },

        /**
         * Add widgets to the scene
         * @returns {Promise} A promise that is resolved
         */
        _performExecution: function() {
            const currentLayer = this._editorViewModel.get("currentLayer");

            // Filter out not-allowed widgets for background scene. WidgetToolboxView is also
            // checking the hideOnBackgroundScene value.
            if (currentLayer === LayerEnum.BACKGROUND) {
                this._widgetModels = _.filter(this._widgetModels, (widget) => {
                    // Reject if any group widget has: `hideOnBackgroundScene`
                    if (widget instanceof CompositeWidgetModel) {
                        var group = widget.get("group").models;
                        var disabledGroupWidget = _.find(group, (groupWidget) => {
                            return WidgetTypes.lookup(groupWidget.get("type")).hideOnBackgroundScene;
                        });

                        if (disabledGroupWidget) {
                            return;
                        }
                    }

                    return !WidgetTypes.lookup(widget.get("type")).hideOnBackgroundScene;
                });
            }

            let modelToAddTo;
            switch (currentLayer) {
                case LayerEnum.SCENE:
                    modelToAddTo = this._sceneModel; // not the activeLayerSceneModel, as the widget may have been dropped onto the non-active scene
                    break;
                case LayerEnum.OVERLAY:
                case LayerEnum.BACKGROUND:
                    modelToAddTo = this._editorViewModel.get("activeLayerSceneModel");
                    break;
                default:
                    throw new Error(`unexpected layer: ${currentLayer.toString()}`);
            }

            let newOptions = {setLayerIndex: true, selectWidget: this._doNotSelect};

            if (this._options) {
                $.extend(newOptions, this._options);
            }

            modelToAddTo.addWidgets(this._widgetModels, newOptions);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/AddWidgetsAction.js